import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { AssignableUserPermission } from '../../domains/userManagement/types';

const ENDPOINT = `${APIConfiguration.authorization}permissions/assignablePermissions`;

export const getAssignablePermissionsRequest = (): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getAssignablePermissionsQuery = async (): Promise<
  BackResponse<AssignableUserPermission[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<AssignableUserPermission[]>>(
      getAssignablePermissionsRequest(),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
